import gsap from "gsap";

export function ArrangeHouse (setting:any, forceMove?:boolean)
{
	const gbt:any = setting.content?.getBoundingClientRect().top;
	const gbh:any = setting.content?.getBoundingClientRect().height;
	const contentLength = gbh-window.innerHeight;
	let posCheck = Math.floor(-gbt/(contentLength/(setting.hauntTotal)));
	let tempcurrentHaunt = Math.min(Math.max(posCheck,0),(setting.hauntTotal-1));

	if(tempcurrentHaunt!=setting.currentHaunt || forceMove){
		if(!forceMove){
			setting.currentHaunt = tempcurrentHaunt;
		}
		if(setting.glb){
			gsap.to(setting.glb.rotation, { 
				duration: 1, 
				ease: "power2.out",
				x: setting.infoSet[setting.currentHaunt].x,
				y: setting.infoSet[setting.currentHaunt].y,
				z: setting.infoSet[setting.currentHaunt].z
			});
			gsap.to(setting.glb.scale, { 
				duration: 1, 
				ease: "power2.out",
				x: setting.infoSet[setting.currentHaunt].scale,
				y: setting.infoSet[setting.currentHaunt].scale,
				z: setting.infoSet[setting.currentHaunt].scale
			});
			let py:any = setting.infoSet[setting.currentHaunt].py;
			if(window.innerWidth<=767 && setting.infoSet[setting.currentHaunt].mpy){
				py = setting.infoSet[setting.currentHaunt].mpy;
			}
			gsap.to(setting.glb.position, { 
				duration: 1, 
				ease: "power2.out",
				x: setting.infoSet[setting.currentHaunt].px,
				y: py,
				z: setting.infoSet[setting.currentHaunt].pz
			});
			if(setting.infoSet[setting.currentHaunt].cx){
				gsap.to(setting.camera.rotation, { 
					duration: 1, 
					ease: "power2.out",
					x: setting.infoSet[setting.currentHaunt].cx,
				});
			}
		}
		if(setting.currentHaunt>=0){
			document.querySelector('.halloween-2025-map .current')?.classList.remove('current');
			document.querySelector('.halloween-2025-map .currentHouse')?.classList.remove('currentHouse');
			if(setting.to){
				clearTimeout(setting.to);
			}
			setting.to = setTimeout(()=>{
				document.querySelectorAll('.halloween-2025-map .hallow-2024-contentTab')[setting.currentHaunt].classList.add('current');
				document.querySelector(`.halloween-2025-map .hallow-2024-miniMapPin[data-pin="house${setting.currentHaunt+1}"]`).classList.add('currentHouse');
			},500)
		}
	}
}